import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { TransactionHistoryStatusColor } from '../transactionhistorystatuscolor';

export interface EnglishTransactionHistoryRowCSSStyle extends UIComponentCSSStyle
{

    getHeader1DivCSSStyle():object;
    getHeader2DivCSSStyle():object;
    getContentCSSStyle():object;
    getValidityHeaderCSSStyle():object;
    getDateLabelCSSStyle():object;
    getChannelTypeCSSStyle():object;
    getValidityCSSStyle():object;
    getBardDivCSSStyle():object;
    getInnerDiv1CSSStyle():object;
    getInnerDiv2CSSStyle():object;
    getLabel1CSSStyle():object;
    getLabel2CSSStyle():object;
    getStatusDivCSSStyle(status:string):object;
    getRoundIconCSSStyle(status:string):object;
    getStatusLabelCSSStyle():object;
    
}

export class  EnglishTransactionHistoryRowCSSStyleImpl extends UIComponentCSSStyleImpl implements EnglishTransactionHistoryRowCSSStyle
{
    
    getWrapperCSSStyle(): object
    {
        return {
            // width:'100%',
            // height:'155px',
            display:'flex',
            borderRadius:'8px',
            // backgroundColor:'#ffffff',
            boxShadow:' 0 2px 10px 0 rgba(0,0,0,0.07)',
            // marginRight:'10px',
            // marginLeft:'10px',
            marginBottom:'20px',
            flexFlow: "row wrap",
            flexDirection:'row',
  
        };
    }
    
   

      getBardDivCSSStyle():object{
          return{
            width:'100%', marginBottom:'5px', height:'1px', backgroundColor:'#EAECEF'
          };
      }
      getInnerDiv1CSSStyle():object
      {
          return{
            width:'100%', height:'100%'
          };
      }

      getInnerDiv2CSSStyle():object
      {
          return{
            width:"100%",display:'flex',height:'30px'
          };
      }


      getHeader1DivCSSStyle():object
      {
          return{
            textAlign:'left',width:'50%',height:'100%'
          };
      }

      getHeader2DivCSSStyle():object
      {
          return{
            textAlign:'right',width:'50%',height:'100%'
          };
      }
      getLabel1CSSStyle():object
      {
          return{
            maxWidth:'80%', height:'30px',fontFamily: this.getResources().getFontFamily(), letterSpacing:'0',overflow: 'hidden',textOverflow: 'ellipsis', lineHeight:'30px',color:'#221E20', fontSize:'13px'
          };
      }

      getLabel2CSSStyle():object
      {
          return{
            width:'100%', height:'30px', fontFamily: this.getResources().getFontFamily(),lineHeight:'30px', fontSize:'13px', fontWeight:500,color:'#7E91A4'
          };
      }

      getContentCSSStyle():object
      {
          return{
            width:'100%', height:'20px',fontFamily: this.getResources().getFontFamily(),lineHeight:'20px',fontSize:'13px', fontWeight:300, color:'#898989'
          };
      }

     getDateLabelCSSStyle():object
     {
         return{
            width:'50%',textAlign:'left',fontFamily: this.getResources().getFontFamily(), height:'20px',lineHeight:'20px',fontSize:'14px', fontWeight:300, color:'#221E20'
         };
     }

     getChannelTypeCSSStyle():object
     {
         return{
            width:'50%',textAlign:'right', fontFamily: this.getResources().getFontFamily(),height:'20px',lineHeight:'20px',fontSize:'14px', fontWeight:300, color:'#221E20'
         };
     }

     getValidityCSSStyle():object{
      return{
        width:'100%',textAlign:'right', fontFamily: this.getResources().getFontFamily(),height:'15px',lineHeight:'15px',fontSize:'14px', fontWeight:300, color:'#221E20'
     };
     }

     getValidityHeaderCSSStyle():object
     {
      return{
        width:'100%', height:'20px',fontFamily: this.getResources().getFontFamily(),lineHeight:'15px',fontSize:'13px', fontWeight:300, color:'#898989'
      };
     }
     getStatusDivCSSStyle(status:string):object
      {
                     return{
                        width:'124px',display:'flex', marginTop:"6px",textAlign:'center', height:'30px',fontFamily: this.getResources().getFontFamily(), fontSize:'15px',fontWeight:900, lineHeight:'30px',borderRadius:'20px', backgroundColor:TransactionHistoryStatusColor.getStatusBackgroundColor(status, this.getContext().getResources()),

                        color:TransactionHistoryStatusColor.getStatusLabelColor(status, this.getContext().getResources())
                     }; 
          
      }


      getRoundIconCSSStyle(status:string):object
      {
          return{
            width:'9px',marginTop:'10.5px',fontFamily: this.getResources().getFontFamily(),marginLeft:'10px', height:'9px',backgroundColor:TransactionHistoryStatusColor.getStatusLabelColor(status, this.getContext().getResources()),borderRadius:'35px'
          };
      }
      getStatusLabelCSSStyle():object
      {
          return{
            maxWidth:'78%',marginLeft:'7px',textOverflow: 'ellipsis',overflow:"hidden" ,fontFamily: this.getResources().getFontFamily(),height:'30px',lineHeight:'30px',textAlign:'left',fontWeight:900,          
          };
      }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/viewmodel/transactionhistoryrowcss.tsx